module.exports = __webpack_public_path__ + "4d052c071a13ee2e24eb154023fe8933.svg";